import dayjs from 'dayjs'

export enum ChartType {
  GPUCore = 1,
  GPURAM = 2,
  CPU = 3,
  Memory = 4,
  Disk = 5,
  Bandwidth = 6,
  Metric,
}

export function enumToChartType(num: number): ChartType {
  switch (num) {
    case 1:
      return ChartType.GPUCore
    case 2:
      return ChartType.GPURAM
    case 3:
      return ChartType.CPU
    case 4:
      return ChartType.Memory
    case 5:
      return ChartType.Disk
    case 6:
      return ChartType.Bandwidth
    case 7:
      return ChartType.Metric
    default:
      throw new Error(`Invalid chart type: ${num}`)
  }
}

export const extractTimePoints = (items: any[]) => {
  const allTimePoints = new Array<dayjs.Dayjs>()
  items.forEach((item) => {
    item.matrixArray.forEach((matrix: any) => {
      matrix.matrix.forEach((m: any, index: number) => {
        if (index === 0) {
          const time = dayjs.unix(m)
          if (!allTimePoints.find((t) => t.isSame(time))) {
            allTimePoints.push(time)
          }
        }
      })
    })
  })

  return allTimePoints
}
